import React from 'react';
import { Helmet } from 'react-helmet-async';
import ThankYouMessage from '../components/signup/ThankYouMessage';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/ThankYou.css';

const ThankYou = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: 'Thank You - Team Agua BJJ Rotterdam',
      description: 'Thank you for joining Team Agua BJJ Rotterdam. Your membership has been activated. See you on the mats!',
    },
    nl: {
      title: 'Bedankt - Team Agua BJJ Rotterdam',
      description: 'Bedankt voor je aanmelding bij Team Agua BJJ Rotterdam. Je lidmaatschap is geactiveerd. Tot op de mat!',
    },
  };

  const text = content[language] || content.en;

  return (
    <div className="thank-you-page">
      <Helmet>
        <title>{text.title}</title>
        <meta name="description" content={text.description} />
        <meta name="robots" content="noindex,follow" />
        <link rel="canonical" href="https://rotterdam.aguabjj.nl/signup/thank-you" />
        
        {/* Open Graph */}
        <meta property="og:title" content={text.title} />
        <meta property="og:description" content={text.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://rotterdam.aguabjj.nl/signup/thank-you" />
        <meta property="og:image" content="https://rotterdam.aguabjj.nl/images/team-agua-500.png" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={text.title} />
        <meta name="twitter:description" content={text.description} />
        <meta name="twitter:image" content="https://rotterdam.aguabjj.nl/images/team-agua-500.png" />
      </Helmet>

      <div className="container">
        <ThankYouMessage />
      </div>
    </div>
  );
};

export default ThankYou;
